import "react-perfect-scrollbar/dist/css/styles.css"
import "bootstrap/dist/css/bootstrap.min.css"
import 'react-tagsinput/react-tagsinput.css'
import 'react-date-picker/dist/DatePicker.css'
import "dropzone/dist/min/dropzone.min.css"

let render = () => {
    import('./assets/css/sass/__styles.scss').then(x => {
        require('./AppRenderer')
    })
}
render()